// Sets the Authorization header for the Echo connector.
// This header is used when the broadcasting/auth endpoint is called.
export function setEchoAuthToken(deviceToken) {
  try {
    const headers = window.Echo?.connector?.options?.auth?.headers;
    if (!headers) return; // Silently fail if Echo isn't ready – effect will guard against this.

    headers.Authorization = deviceToken ? `Bearer ${deviceToken}` : "";
  } catch (e) {
    // Fail silently – no need to crash the app for an auth header.
    // console.log("setEchoAuthToken error:", e);
  }
}
